<div class="landing-image">
  <img [src]="sanitize(data?.landingImage ?? '')" />
  <div class="centered-text">
    <div class="logo">COME<b>TRALCI</b></div>
    <div class="negative">benvenuto</div>
  </div>
  <div class="scrolldown-wrapper">
    <div class="center">
      <div class="arrow"></div>
    </div>
  </div>
</div>

<!-- <div class="live">
  <iframe
    width="560"
    height="315"
    src="https://www.youtube.com/embed/wgASJPcRCNk?si=mGnatDoEWanwc-Bz"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>
</div> -->

<!-- <div class="title-container">
  <div class="title">
    RADICATI IN CRISTO<br />
    PORTIAMO FRUTTO<br />
    NEL MONDO<br />
    <app-youtube></app-youtube>
    <app-cta link="/mappa" text="vieni a trovarci"></app-cta>
  </div>
</div> -->

<div class="title-container">
  <div class="title">
    "BEATA LA NAZIONE<br />IL CUI DIO È IL
    <span class="serif">SIGNORE</span>"<br />
    <div class="verse">Salmi 33:12</div>
    <app-youtube></app-youtube>
    <app-cta link="/mappa" text="vieni a trovarci"></app-cta>
  </div>
</div>

<app-media-card
  title="UNA CHIESA, UN CORPO, UNA MISSIONE"
  description="Una chiesa di credenti che hanno ricevuto Gesù Cristo come Salvatore e Lo
      riconoscono pubblicamente come Signore. Siamo parte del corpo di Cristo e
      della chiesa universale, uniti per adorare Dio, edificarci a vicenda e
      servirLo nel mondo secondo le Sacre Scritture."
  imageUrl="/images/photo12.JPG"
  btnText="scopri di più"
  link="/chi-siamo"
></app-media-card>

<!-- Banner Oltre i miei limiti (temporaneamente nascosto)
<a class="release-banner" routerLink="/worship/oltre-i-miei-limiti">
  <img
    class="release-cover"
    src="/images/worship/oltre-i-miei-limiti-cover.jpg"
    alt="Copertina di Oltre i miei limiti"
  />
  <div class="release-text">
    <div class="release-eyebrow">ComeTralci Worship &middot; Nuovo singolo</div>
    <div class="release-title">OLTRE I MIEI <b>LIMITI</b></div>
    <div class="release-date">
      Fuori il <strong>24 luglio</strong> &middot; ascolta l'anteprima e
      pre-salvala
    </div>
    <span class="release-cta">&raquo; vai alla pagina</span>
  </div>
</a>
-->

<a class="release-banner release-banner-cielo" routerLink="/worship/il-cielo-canta-santo">
  <img
    class="release-cover release-cover-cielo"
    src="/images/worship/il-cielo-canta-santo-cover.jpg"
    alt="Copertina di Il Cielo canta Santo"
  />
  <div class="release-text">
    <div class="release-eyebrow">ComeTralci Worship &middot; Nuova cover</div>
    <div class="release-title">IL CIELO CANTA <b>SANTO</b></div>
    <div class="release-date">
      Fuori ora &middot; guarda il video live su <strong>YouTube</strong>
    </div>
    <span class="release-cta">&raquo; vai alla pagina</span>
  </div>
</a>

<div class="contact-us-home" id="contatti">
  <div class="title">Hai bisogno di aiuto?</div>
  <br />
  <div class="contact-info">
    <div class="email-section">
      Scrivi all'email:<br />
      <a href="mailto:info.chiese@cometralci.com"
        >info.chiese&#64;cometralci.com</a
      >
    </div>
    <div class="tel-section">
      Oppure chiamaci al numero:<br />
      <a href="tel:0371 977 626">0371 977 626</a>
    </div>
  </div>

  <!-- 
<app-map></app-map> -->
  <!-- 

<div class="verticalbg">
  <div class="text">
    UN TESTO CASUALE CHE PARLA DI QUALCOSA
    <br /><br /><br />
    <div class="desc">
      OUR TEAM IS COMMITTED TO WORKING CLOSELY WITH ARTISTS TO UNDERSTAND THEIR
      ARTISTIC VISION, GOALS, AND UNIQUE STRENGTHS. BY PROVIDING EXPERT
      GUIDANCE, STRATEGIC PLANNING, AND UNWAVERING SUPPORT
    </div>
    <div class="desc">
      OUR TEAM IS COMMITTED TO WORKING CLOSELY WITH ARTISTS TO UNDERSTAND THEIR
      ARTISTIC VISION, GOALS, AND UNIQUE STRENGTHS. BY PROVIDING EXPERT
      GUIDANCE, STRATEGIC PLANNING, AND UNWAVERING SUPPORT
    </div>
    <div class="desc">
      OUR TEAM IS COMMITTED TO WORKING CLOSELY WITH ARTISTS TO UNDERSTAND THEIR
      ARTISTIC VISION, GOALS, AND UNIQUE STRENGTHS. BY PROVIDING EXPERT
      GUIDANCE, STRATEGIC PLANNING, AND UNWAVERING SUPPORT
    </div>
  </div>
</div>

<div class="carousel-container">
  <div class="carousel-track">
    <img src="/images/photo1.JPG" />
    <img src="/images/photo2.JPG" />
    <img src="/images/photo3.JPG" />
    <img src="/images/photo4.JPG" />
    <img src="/images/photo5.JPG" />
    <img src="/images/photo6.JPG" />
    <img src="/images/photo7.JPG" />
    <img src="/images/photo8.JPG" />
    <img src="/images/photo9.JPG" />
    <img src="/images/photo10.JPG" />
    <img src="/images/photo11.JPG" />
    <img src="/images/photo12.JPG" />
    <img src="/images/photo13.JPG" />
    <img src="/images/photo14.JPG" />
    <img src="/images/photo15.JPG" />
    <img src="/images/photo16.JPG" />
    <img src="/images/photo1.JPG" />
    <img src="/images/photo2.JPG" />
    <img src="/images/photo3.JPG" />
    <img src="/images/photo4.JPG" />
    <img src="/images/photo5.JPG" />
    <img src="/images/photo6.JPG" />
    <img src="/images/photo7.JPG" />
    <img src="/images/photo8.JPG" />
    <img src="/images/photo9.JPG" />
    <img src="/images/photo10.JPG" />
    <img src="/images/photo11.JPG" />
    <img src="/images/photo12.JPG" />
    <img src="/images/photo13.JPG" />
    <img src="/images/photo14.JPG" />
    <img src="/images/photo15.JPG" />
    <img src="/images/photo16.JPG" />
  </div>
</div>

<br />
<div class="social">
  seguici su
  <a href="https://instagram.com" target="_blank">
    <img src="/icons/instagram.svg" />
  </a>

  <a href="https://facebook.com" target="_blank">
    <img src="/icons/facebook.svg" class="fb-icon" />
  </a>

  <a href="https://youtube.com" target="_blank">
    <img src="/icons/youtube.svg" class="yt-icon" />
  </a>
</div>
<div class="contact" id="footer">
  <div class="title">CONTATTACI</div>
  <div class="email">
    <a href="mailto:info.chiese@cometralci.com"
      >info.chiese&#64;cometralci.com</a
    >
  </div>
</div>
<br />
<br />
<br />
<br /> -->
</div>
